<template>
  <div class="list-card__body--item is-flex is-align-items-center">
    <div class="list-card__body--item-text light-weight is-mr-5 is-flex" v-if="is_edit ==-1">
      <div class="drag-icon">
        <img src="../../../../../../../../../assets/icons/row-drag.svg" alt="" srcset="">
      </div>
      <div class="is-flex is-align-items-center">
          <i class="fas fa-circle" style="margin-right:.5rem;" :style="{'color':feature_type.properties.color}"></i>
        <div class="is-regular-16-000-19" style="color: #171e48;margin-bottom:0.1rem;" v-tooltip="feature_type.name">{{feature_type.name | truncate(30) }}</div>
      </div>
    </div>
    <div class="list-card__body--item-text control has-icons-left has-icons-right" v-else>
      <input
        type="text"
        name="feature type name"
        id="name"
        v-model="feature_group.name"
        :placeholder="feature_type.name"
        class="input is-small"
        @keyup.enter="save_group"
        @click="is_color_list=!is_color_list"
      />
      <span class="icon is-small is-left is-pointer">
        <i :style="{'color':feature_group.properties.color}" class="fas fa-circle"></i>
      </span>
      <div v-if="is_color_list" class="color-list has-text-centered">
        <i
          v-for="(color,i) in color_list"
          :key="i"
          class="fa fa-circle is-pointer"
          :style="{'color':color.color}"
          @click="feature_group.properties.color=color.color"
        ></i>
      </div>
    </div>
    <div class="list-card__body--item-action is-flex is-align-items-center">
      <div class="is-mx-5 is-medium-16-500-19">
        {{feature_type.feature_count}}
      </div>
      <div class="is-mx-5">
        <svg v-if="is_edit == -1" @click="edit_group" viewBox="0 0 100 100" class="image is-24x24 ml-20 is-pointer">
          <use xlink:href="@/assets/icons/helper_sprite.svg#edit-small" />
        </svg>
        <svg v-else @click="save_group" viewBox="0 0 100 100" :class="{'is-disabled':!feature_type.name}" class="image is-24x24 ml-20 is-pointer">
          <use xlink:href="@/assets/icons/helper_sprite.svg#tick" />
        </svg>
      </div>
      <div class="is-mx-5">
        <svg @click="deleteFeatureType()" viewBox="0 0 100 100" class="image is-24x24 ml-20 is-pointer ">
          <use xlink:href="@/assets/icons/helper_sprite.svg#delete-small" />
        </svg>
      </div>

      <!-- <i @click="deleteFeatureType()" class="fa fa-trash ml-10"></i> -->
    </div>
  </div>
</template>

<script>
import FeatureTypeService from "@/services/feature-type.service";
const featureTypeService = new FeatureTypeService();
export default {
  props: ["feature_type", "color_list"],
  data() {
    return {
      is_edit: -1,
      feature_group: this.feature_type,
      is_color_list: false
    };
  },
  methods: {
    deleteFeatureType() {
      this.$dialog.confirm({
        type: "is-danger",
        message: `Are you sure?`,
        confirmText: "Yes",
        cancelText: "No",
        onConfirm: async () => {
          try {
            await featureTypeService.delete({
              uid: this.feature_type.uid
            });
            this.$emit("onDeleteFeature");
            this.$toast.open("Deleted successfully!");
          } catch (err) {
            this.handleErrors(err);
          }
        }
      });
    },
    edit_group() {
      this.is_edit = 1;
    },
    async save_group() {
      try {
        if (!this.feature_group.properties.color) {
          this.$toast.open(this.localization('app-please-select-the-color','"Please select the color."'));
          return;
        }
        if (this.is_edit) {
          this.is_edit = false;
          await featureTypeService.patch({
            uid: this.feature_group.uid,
            body: {
              name: this.feature_group.name,
              properties: this.feature_group.properties
            }
          });
          this.is_edit = -1;
          this.$emit("feature_type_updated");
        }
      } catch (err) {
        this.handleErrors(err);
      }
    }
  }
};
</script>
<style scoped lang="scss">
.list-card__body--item {
  cursor: grab;
  border: solid 1px #ffffff;
  margin: 4px 10px;
  position: relative;

  &:hover {
    background-color: #ffffff;
    border-radius: 6px;
    box-shadow: 0 2px 4px 0 rgba(23, 30, 72, 0.07);
    border: solid 1px rgba(23, 30, 72, 0.15);
    margin: 4px 10px;

    .drag-icon {
      display: block;
      position: absolute;
      left: -30px;
      z-index: 0 !important;
    }
  }

  &:active {
    cursor: grabbing;
    border: solid 1px #ffffff;
  }

  .drag-icon {
    display: none;
  }
}
</style>